import { KeyTypes } from '@infotech-soe/mia-ds-service/types';
import { defineMessages } from 'react-intl';

export const dsFormMessages = defineMessages({
  password: {
    id: 'core.loginForm.password',
    defaultMessage: 'Password:',
  },
  saveCredentials: {
    id: 'core.loginForm.saveCredentials',
    defaultMessage: 'Save credentials',
  },
  sign: {
    id: 'core.category.commands.sign',
    defaultMessage: 'Sign',
  },
  keyType: {
    id: 'core.loginForm.keyType',
    defaultMessage: 'Key type',
  },
  [KeyTypes.DEVICE]: {
    id: 'core.loginForm.hardwareKey',
    defaultMessage: 'Hardware key',
  },
  [KeyTypes.FILE]: {
    id: 'core.loginForm.fileKey',
    defaultMessage: 'File key',
  },
  deviceType: {
    id: 'core.loginForm.deviceType',
    defaultMessage: 'Device type',
  },
  device: {
    id: 'core.loginForm.device',
    defaultMessage: 'Device',
  },
  authority: {
    id: 'core.loginForm.authority',
    defaultMessage: 'KNDEP/ ACSK:',
  },
});

export const notAvailableFormMessages = defineMessages({
  title: {
    id: 'core.loginForm.notAvailableForm.title',
    defaultMessage: 'Please check the following components to sign in :',
  },
  agentLink: {
    id: 'core.loginForm.notAvailableForm.agentLink',
    defaultMessage: 'digital signature agent',
  },
  javaLink: {
    id: 'core.loginForm.notAvailableForm.javaLink',
    defaultMessage: 'java environment',
  },
  access: {
    id: 'core.loginForm.notAvailableForm.access',
    defaultMessage: 'You must also be sure that you have access rights',
  },
});

export const signFormMessages = defineMessages({
  title: {
    id: 'core.signForm.title',
    defaultMessage: 'Choose digital sgnature key',
  },
});
